import {useTranslation} from "next-i18next";

interface TempProps {
    from?: string;
    to?: string;
}

// be sure to check the content.ts file which makes some replacements of the original markdown

const convertCtoF = (inputC: number) => {
    if (isNaN(inputC)) {
        return null
    }
    {
        return Math.round((inputC * 1.8) + 32)
    }
}

export function Temp({from, to}: TempProps) {

    const {t, i18n} = useTranslation();

    const isEnglish = i18n.language == "en"

    let output = null

    const fromC = parseFloat(from ?? "")
    const toC = parseFloat(to ?? "")

    const fromF = convertCtoF(fromC)
    const toF = convertCtoF(toC)

    if (!isNaN(fromC)) { // fromC defined

        if (!isNaN(toC)) {
            // {{$fromC}}° {{ i18n "temp-to" | safeHTML }} {{$toC}}°C{{ if $isEnglish }} ({{$fromF}}° {{ i18n "temp-to" | safeHTML }} {{$toF}}°F){{ end }}
            output = <>{fromC}° {t("temp-to")} {toC}°C{isEnglish ? <> ({fromF}° {t("temp-to")} {toF}°F)</> : null} </>
        } else {
            //{{$fromC}}°C{{ if $isEnglish }} ({{$fromF}}°F){{ end }}
            output = <>{fromC}°{isEnglish ? <> ({fromF}°F)</> : null} </>
        }
    } else {

        if (!isNaN(toC)) { // toC defined
            //{{$fromC}}° {{ i18n "temp-to" | safeHTML }} {{$toC}}°C{{ if $isEnglish }} ({{$fromF}}° {{ i18n "temp-to" | safeHTML }} {{$toF}}°F){{ end }}
            output = <>{fromC}° {t("temp-to")} {toC}°C{isEnglish ? <> ({fromF}° {t("temp-to")} {toF}°F)</> : null} </>
        } else {
            //{{$fromC}}°C{{ if $isEnglish }} ({{$fromF}}°F){{ end }}
            output = <>{fromC}°{isEnglish ? <> ({fromF}°F)</> : null} </>
        }


    }


    return <span style={{}}>{output}</span>;
    // return <span style={{color: "goldenrod"}}>{JSON.stringify(props)}</span>;
}
